import { render } from "./App.vue?vue&type=template&id=ba14613a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=ba14613a&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=ba14613a&lang=css"

import exportComponent from "/Users/neiloswald/Workspace/ionic/mtzoom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba14613a"]])

export default __exports__